// General
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { change, formValueSelector, reset } from 'redux-form';
import { setPersonalizedValues } from '../../actions/personalized';

// Redux
import { connect } from 'react-redux';

// Locale
import messages from '../../locale/messages';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { Button } from 'react-bootstrap';
import s from './Search.css';

// Components
import SearchForm from '../../components/SearchListing/SearchForm';
import SearchResults from '../../components/SearchListing/SearchResults';
import MapResults from '../../components/SearchListing/MapResults';
import Loader from '../../components/Loader';
import SortBar from './../../components_new/SortBar';
import SearchFormWrapper from './../../components/SearchListing/SearchForm/SearchFormWrapper';
import { Flex, Box } from 'rebass';
import { colors } from '../../tailwind';
import { Text } from '../../components_new/common';

// Constants
import { googleMapAPI } from '../../config';
import GoogleMapLoader from 'react-google-maps-loader';

// Redux Action
import {
  showMap,
  showResults,
  showForm,
} from '../../actions/mobileSearchNavigation';
import styled from 'styled-components';
import history from '../../core/history';
import CustomPagination from '../../components/SearchListing/CustomPagination/CustomPagination';
import { buildQueryStr } from './Search.logic';

class Search extends React.Component {
  state = {
    darkenBackground: false,
    sortBarCurrentSelection: null,
    filtering: false,
    categories: [],
    query: [],
    currentPage: 1,
  };

  static propTypes = {
    initialFilter: PropTypes.object,
    filterToggle: PropTypes.bool,
    showMap: PropTypes.func.isRequired,
    showResults: PropTypes.func.isRequired,
    showForm: PropTypes.func.isRequired,
    formatMessage: PropTypes.func,
    mobileSearch: PropTypes.shape({
      searchMap: PropTypes.bool,
      searchResults: PropTypes.bool,
      searchForm: PropTypes.bool,
    }),
  };

  static defaultProps = {
    mobileSearch: {
      searchMap: false,
      searchResults: true,
      searchForm: false,
    },
  };

  darkenBackground = () => {
    this.setState({ darkenBackground: true });
  };
  removeBackground = () => {
    this.setState({ darkenBackground: false, sortBarCurrentSelection: null });
  };
  updateSelection = val => {
    this.setState({ sortBarCurrentSelection: val });
  };

  componentDidUpdate = () => {
    const { fieldsSettingsData, query, change } = this.props;
    if (
      !this.state.categories.length &&
      fieldsSettingsData &&
      fieldsSettingsData.roomType &&
      fieldsSettingsData.roomType.length
    ) {
      this.setState({
        categories: fieldsSettingsData.roomType,
      });
    }

    if (this.state.query !== query) {
      const categories = [];
      _.forEach(query, (v, k) => {
        if (k === 'category') {
          categories.push(v);
        } else {
          change('SearchForm', k, v);
        }
      });
      if (categories.length > 0) {
        change('SearchForm', 'roomType', categories);
      }
      this.setState({
        query,
      });
    }
  };

  mobileNavigation() {
    const {
      mobileSearch: { searchMap, searchResults },
      showMap,
      showResults,
      showForm,
    } = this.props;

    let leftNav, rightNav;
    if (searchResults) {
      leftNav = (
        <Button
          className={cx(s.filterButton)}
          bsStyle="link"
          onClick={() => showMap()}
        >
          <FormattedMessage {...messages.map} />
          <i className="fa fa-map-O" />
        </Button>
      );
      rightNav = (
        <Button
          className={cx(s.filterButton)}
          bsStyle="link"
          onClick={() => showForm()}
        >
          <FormattedMessage {...messages.filters} />
          <i className="fa fa-sliders" />
        </Button>
      );
    }

    if (searchMap) {
      // Is this 'search as i move the map?'

      leftNav = (
        <Button
          className={cx(s.filterButton)}
          bsStyle="link"
          onClick={() => showResults()}
        >
          <FormattedMessage {...messages.results} />
          <i className="fa fa-ellipsis-h" />
        </Button>
      );
      rightNav = (
        <Button
          className={cx(s.filterButton)}
          bsStyle="link"
          onClick={() => showForm()}
        >
          <FormattedMessage {...messages.filters} />
          <i className="fa fa-sliders" />
        </Button>
      );
    }

    return (
      <div className={cx(s.mobileNavigation)}>
        <div className={s.buttonOuter}>
          <div className={cx(s.buttonContainer)}>
            {leftNav}
            {rightNav}
          </div>
        </div>
      </div>
    );
  }

  closeFilter = () => {
    this.setState({
      filtering: false,
    });
  };

  handlePagination = async (currentPage, size) => {
    const { query } = this.props;
    this.setState({
      currentPage,
    });
    const q3 = buildQueryStr(query, currentPage);

    history.push(q3);
  };

  render() {
    const {
      mobileSearch: { searchMap, searchResults, searchForm },
      initialFilter,
      filterToggle,
      query,
      total,
    } = this.props;

    const { filtering, currentPage } = this.state;

    let DesktopResults = true;
    if (filterToggle === true) {
      DesktopResults = false;
    }

    const isBrowser = typeof window !== 'undefined';
    const smallDevice = isBrowser
      ? window.matchMedia('(max-width: 768px)').matches
      : undefined;

    if (!isBrowser) {
      return (
        <div className={s.searchLoaderContainer}>
          <Loader type={'text'} />
        </div>
      );
    }

    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={cx(s.searchResultContainer)}>
            <SearchForm
              initialFilter={initialFilter}
              query={query}
              currentPage={currentPage}
            />

            {!smallDevice && DesktopResults && (
              <div
                className={cx(s.resultsBody)}
                style={{
                  display: filtering ? 'none' : null,
                }}
              >
                <SearchResults />
              </div>
            )}

            {smallDevice && searchResults && (
              <div
                className={cx(s.resultsBody)}
                style={{
                  display: filtering ? 'none' : null,
                }}
              >
                <SearchResults />
              </div>
            )}
            <div className={s.resultsFooter}>
              <div className={s.resultsPagination}>
                <div className={s.pagination}>
                  <CustomPagination
                    total={total}
                    current={currentPage}
                    defaultCurrent={1}
                    defaultPageSize={10}
                    handleChange={this.handlePagination}
                  />
                </div>
              </div>
            </div>
          </div>
          <GoogleMapLoader
            params={{
              libraries: 'places',
              region: 'US',
              language: 'en',
              key: googleMapAPI,
            }}
            render={googleMaps =>
              googleMaps
                ? (!smallDevice && (
                    <div className={cx(s.searchMapContainer)}>
                      <MapResults
                        initialFilter={initialFilter}
                        googleMaps={googleMaps}
                      />
                    </div>
                  )) ||
                  (smallDevice && searchMap && (
                    <div className={cx(s.searchMapContainer)}>
                      <MapResults
                        initialFilter={initialFilter}
                        googleMaps={googleMaps}
                      />
                    </div>
                  ))
                : null
            }
          />

          {!searchForm && this.mobileNavigation()}
        </div>
      </div>
    );
  }
}

const selector = formValueSelector('SearchForm');

const mapState = state => ({
  filterToggle: state.toggle.filterToggle,
  mobileSearch: state.mobileSearch.data,
  fieldsSettingsData: state.listingFields.data,
  total: state.search.count,
  searchForm: selector(
    state,
    'roomType',
    'keyword',
    'location',
    'dates',
    'minRating',
    'priceMin',
    'priceMax',
    'lat',
    'lng',
    'searchByMap',
    'sw_lat',
    'sw_lng',
    'ne_lat',
    'ne_lng',
  ),
});

const mapDispatch = {
  showMap,
  showResults,
  showForm,
  setPersonalizedValues,
  change,
  reset,
};

export default withStyles(s)(
  connect(
    mapState,
    mapDispatch,
  )(Search),
);

// <SearchFormWrapper>
// <SortBar
//   setPersonalizedValues={this.props.setPersonalizedValues}
//   dateFilterChange={val =>
//     this.props.change('SearchForm', 'dates', val)
//   }
//   darkenBackground={this.darkenBackground}
//   updateSelection={this.updateSelection}
//   removeBackground={this.removeBackground}
//   currentSelection={this.state.sortBarCurrentSelection}
// />
// </SearchFormWrapper>



// WEBPACK FOOTER //
// ./src/routes/search/Search.js